import { gql } from "gql";

export const GET_HR_SETTINGS = gql(/* GraphQL */ `
  query GetHrSettings {
    getHrSettings {
      ...HrSettings
    }
  }
`);
